import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import CapitalRequirements from './CapitalRequirements';
import { calculateRequiredCapital } from '@/lib/calculateRequiredCapital';

const CollapsibleAccountInfo = ({
  strategyType,
  parameters,
  accountBalance = 100000,
  buffer = 20,
  onBufferChange,
}) => {
  const [expanded, setExpanded] = useState(false);

  const requiredCapital = calculateRequiredCapital(strategyType, parameters);
  const totalRequired = requiredCapital + (requiredCapital * buffer) / 100;

  const fmt = (v) => '$' + v.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      {/* Collapsed summary row */}
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between px-3 py-2.5 text-sm hover:bg-accent/5 transition-colors"
      >
        <div className="flex items-center gap-3 text-xs">
          <span className="text-muted-foreground">
            Buying Power: <span className="font-semibold text-foreground">{fmt(accountBalance)}</span>
          </span>
          <span className="text-border/50">|</span>
          <span className="text-muted-foreground">
            Required: <span className={`font-semibold ${totalRequired > accountBalance ? 'text-red-400' : 'text-green-400'}`}>{fmt(totalRequired)}</span>
          </span>
        </div>
        <ChevronDown className={`h-4 w-4 text-muted-foreground transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {/* Expanded: full CapitalRequirements */}
      {expanded && (
        <div className="px-3 pb-3 border-t border-border">
          <CapitalRequirements
            strategyType={strategyType}
            parameters={parameters}
            accountBalance={accountBalance}
            buffer={buffer}
            onBufferChange={onBufferChange}
          />
        </div>
      )}
    </div>
  );
};

export default CollapsibleAccountInfo;
